import { QueryClientProvider } from "@tanstack/react-query";
import React, { useMemo } from "react";
import { createUnauthenticatedQueryClient } from "src/services/createQueryClient";
import * as Env from "src/services/env";

type Props = { children: React.ReactElement };

export const UnauthenticatedQueryClientProvider: React.FC<Props> = ({
  children,
}) => {
  const env = Env.read();

  // Create a single QueryClient and configure both REST clients
  // React Query only supports one QueryClient per context, but we can configure
  // multiple REST clients (form-service and avela-ai) to work with it
  // Configure clients only when we have authenticated data
  const queryClient = useMemo(
    () =>
      createUnauthenticatedQueryClient(
        env.VITE_CONFIG_URL,
        env.VITE_FORM_SERVICE_BASE_URL
      ),
    [env.VITE_CONFIG_URL, env.VITE_FORM_SERVICE_BASE_URL]
  );

  return (
    <QueryClientProvider client={queryClient}>{children}</QueryClientProvider>
  );
};
